import { Button, Layout, Result } from "antd";
import { Content } from "antd/lib/layout/layout";
import { FunctionComponent } from "react";
import { Link } from "react-router-dom";

interface NotFoundPageProps {
  homePage: string;
}

const NotFoundPage: FunctionComponent<NotFoundPageProps> = ({ homePage }) => {
  return (
    <Layout>
      <Content>
        <Result
          title="Not Found"
          subTitle="The content you are looking for not found!"
          status={404}
          extra={
            <Link to={{ pathname: homePage }}>
              <Button>Home</Button>
            </Link>
          }
        />
      </Content>
    </Layout>
  );
};

export default NotFoundPage;
